<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Quote list</h4>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-sm btn-primary" @click="fnGoNewQuote()">
              New
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>
          <div class="dealer-user-box item">
            <label class="mb-0">Select with search</label>
            <multiselect
              v-model="dealerUser"
              :options="userDropdownList"
              placeholder="Select one"
              label="fullName"
              track-by="id"
            ></multiselect>
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option
                v-for="item in optionStatus"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
          <div class="date-box item">
            <label for="paginate" class="mb-0"
              >From <WDDateStatus :status="selectedStatus"
            /></label>
            <datePicker
              :editable="true"
              value-type="YYYY-MM-DD"
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              v-model="fromDate"
            ></datePicker>
          </div>
          <div class="date-box item">
            <label for="paginate" class="mb-0"
              >To <WDDateStatus :status="selectedStatus"
            /></label>
            <datePicker
              :editable="true"
              value-type="YYYY-MM-DD"
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              v-model="toDate"
            ></datePicker>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnExport()">
              Export
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item"></th>

                <th class="header-item v-th-80">
                  <a href="#" @click.prevent="fnChangeSort('id')">Quote Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">Source</th>

                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('dealer')">Dealer</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'dealer'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'dealer'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('createdBy')"
                    >Dealer User</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'createdBy'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'createdBy'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('client')"
                    >Client Name</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'client'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'client'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">Income</th>
                <th class="header-item">
                  <a
                    href="#"
                    @click.prevent="fnChangeSort('firstSubmittedDate')"
                    >Submitted Date</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' &&
                      sort_field == 'firstSubmittedDate'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' &&
                      sort_field == 'firstSubmittedDate'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('edd')"
                    >Est. Delivery Date</a
                  >
                  <span v-if="sort_direction == 'desc' && sort_field == 'edd'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'edd'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('settlementDate')"
                    >Settlement Date</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'settlementDate'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' && sort_field == 'settlementDate'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">
                  <a href="#" @click.prevent="fnChangeSort('sortOrder')"
                    >Status</a
                  >
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'sortOrder'"
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'sortOrder'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, index) in getAdminQuotePaginateData.data">
                <tr :key="(row, index)">
                  <td
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span class="text-info pl-2"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>
                  <td>{{ row.id }}</td>
                  <td>
                    {{ row.quoteSource }}
                  </td>
                  <td>{{ row.dealer }}</td>
                  <td>{{ row.dealer_user }} {{ row.dealer_user_last_name }}</td>
                  <td class="column-2">
                    <span
                      >{{ row.client }} |
                      <span class="text-black-60 fs-600">
                        {{ row.hAddressState }}</span
                      ></span
                    >
                    <br />
                    <span class="text-black-60 fs-600">{{
                      row.employerName
                    }}</span>
                  </td>

                  <td>
                    {{ (Number(row.totalDriveAwayCost) * (Number(row.dealerBrokerage) + Number(row.brokerageVSA))) + (Number(row.leaseAdminFeeVSA)) | with-decimal }}
                  </td>
                  <td>
                    {{ row.firstSubmittedDate | dateConvertDDMMYYYY }}
                  </td>
                  <td>
                    {{ row.edd | dateConvertDDMMYYYY }}
                  </td>
                  <td>
                    {{ row.settlementDate | dateConvertDDMMYYYY }}
                  </td>
                  <td class="v-td-center">
                    <WDQuoteStatusBadge
                      :status="row.status"
                    ></WDQuoteStatusBadge>
                  </td>
                  <td class="v-td-center">
                    <div class="d-flex">
                      <a
                        @click="fnGoViewQuote(row.id)"
                        v-b-tooltip.hover
                        title="View quote"
                        class="d-inline pr-2"
                        ><i class="far fa-eye text-primary fs-1000"></i
                      ></a>
                      <a
                        @click="fnGoEditQuote(row.id)"
                        v-b-tooltip.hover
                        title="Update quote"
                        class="d-inline pr-2"
                        ><i class="far fa-edit text-primary fs-1000"></i
                      ></a>
                      <div class="d-inline pr-2">
                        <appModalQuoteStatusUpdate :quoteId="row.id">
                        </appModalQuoteStatusUpdate>
                      </div>
                      <appModalDocumentsUpload
                        :quoteId="row.id"
                        :quoteType="'quote'"
                      >
                      </appModalDocumentsUpload>

                      <div>
                        <a
                          @click="fnDownloadFinanceDoc(row)"
                          class="d-inline pr-2 pl-2"
                          v-b-tooltip.hover
                          title="Download finance application"
                          v-if="row.status >= 2"
                        >
                          <i class="las la-download text-primary fs-1000"></i>
                        </a>
                        <span v-else
                          ><i class="las la-hand-paper fs-1000 pl-2 pr-2"></i
                        ></span>
                      </div>
                      <div class="d-inline pr-2">
                        <appModalQuoteTransfer :rowData="row">
                        </appModalQuoteTransfer>
                      </div>
                      <appModalMsgVSA
                        :quoteId="row.id"
                        :quote="row"
                        class="d-inline"
                      ></appModalMsgVSA>
                    </div>
                  </td>
                </tr>

                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <td colspan="12">
                    <div class="row mr-2 ml-2">
                      <div class="col-lg-4 col-md-4 col-12">
                        <dl class="row">
                          <dt class="col-sm-5">Updated</dt>
                          <dd class="col-sm-7">{{ row.updated_at }}</dd>
                          <dt class="col-sm-5">Finance Application No.</dt>
                          <dd class="col-sm-7">{{ row.fa_no }}</dd>
                          <dt class="col-sm-5">Financier</dt>
                          <dd class="col-sm-7">{{ row.financier }}</dd>
                          <dt class="col-sm-5">Pricing Document</dt>
                          <dd class="col-sm-7" v-if="row.pricingDocumentUrl">
                            <a
                              class="text-primary fw-600"
                              :href="row.pricingDocumentUrl"
                              target="_blank"
                              >View document</a
                            >
                          </dd>
                        </dl>

                        <!-- List of  application notes-->
                        <dl class="row" v-if="row && row.notes">
                          <dt class="col-sm-12">Application Notes</dt>
                          <dd class="col-sm-12">
                            <div>
                              <b-card-text
                                v-html="row.notes.applicationNotes"
                              ></b-card-text>
                            </div>
                          </dd>
                        </dl>
                      </div>
                      <div class="col-lg-8 col-md-8 col-12">
                        <!-- VSA quotes and leads logs -->
                        <WDVsaQuoteLeadsLogs
                          v-if="row.vsa_logs.length"
                          :vsaLogs="row.vsa_logs"
                        ></WDVsaQuoteLeadsLogs>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="12">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getAdminQuotePaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'laravel-vue-pagination'
import * as messageService from '../../../services/message.service'
import * as quoteService from '../../../services/quote.service'
import datePicker from 'vue2-datepicker'

import { mapGetters, mapActions } from 'vuex'
import { optionStatus } from '../../../services/data.service'
import appModalQuoteStatusUpdate from '../../../components/admin/ModalQuoteStatusUpdate.vue'
import store from '../../../store/modules/base.module'
import * as taxTableService from '../../../services/taxTable.service'

import * as quoteCalculationService from '../../../services/quoteCalculation.service'
import appModalDocumentsUpload from '../../../components/quote/ModalDocumentsUpload.vue'
import appModalMsgDealer from '../../../components/quote/ModalMsgDealer.vue'
import appModalQuoteTransfer from '../../../components/admin/ModalQuoteTransfer.vue'
import appModalMsgVSA from '../../../components/quote/ModalMsgVSA.vue'
import WDQuoteStatusBadge from '../../../components/wd/WDQuoteStatusBadge.vue'
import WDVsaQuoteLeadsLogs from '../../../components/wd/WDVsaQuoteLeadsLogs.vue'
import WDDateStatus from '../../../components/wd/WDDateStatus.vue'

export default {
  name: 'adminQuoteList',
  props: ['quoteType'],
  components: {
    pagination,
    datePicker,
    appModalQuoteStatusUpdate,
    appModalDocumentsUpload,
    appModalMsgDealer,
    appModalMsgVSA,
    appModalQuoteTransfer,
    WDQuoteStatusBadge,
    WDVsaQuoteLeadsLogs,
    WDDateStatus
  },
  data() {
    return {
      isDataFetch: true,
      optionStatus: optionStatus,
      opened: [],
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      dealerUser: '',
      fromDate: '',
      toDate: '',
      sort_direction: 'asc',
      sort_field: 'sortOrder',
      quoteCalculation: {},
      paginate: {
        dealerUserId: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        fromDate: '',
        toDate: '',
        sort_direction: 'asc',
        sort_field: 'sortOrder'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getQuoteSingle',
      'getAdminQuotePaginateData',
      'getAdminQuotePaginate',
      'getUserDropdownListBasedFullName'
    ]),
    userDropdownList() {
      return this.getUserDropdownListBasedFullName
    }
  },
  methods: {
    ...mapActions([
      'fetchQuoteSingle',
      'fetchAdminQuotePaginate',
      'fetchUserDropdownListBasedFullName'
    ]),
    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    fnGoNewQuote() {
      this.$router.push({ name: 'admin.quoteNew' })
    },
    fnGoViewQuote(id) {
      this.$router.push({ name: 'admin.quoteView', params: { quoteId: id } })
    },
    fnGoEditQuote(id) {
      this.$router.push({ name: 'admin.quoteEdit', params: { quoteId: id } })
    },
    async fnDownloadFinanceDoc(quote) {
      const quoteId = quote.id
      const statusId = quote.status

      try {
        // Get the single quote information to Quote Calculation
        await this.fetchQuoteSingle({ id: quoteId, quoteType: this.quoteType })

        let quoteCalculation = await this.fnQuoteCalculation(
          this.quoteType,
          quoteId,
          this.getQuoteSingle
        )

        // Create a finance excel file in the backend and fet the file name and path
        let obj1 = {
          quoteId: quoteId,
          quoteCalculation: quoteCalculation
        }

        //this.fnDownloadOnClick(obj1)

        const filePath = await quoteService.createFinanceDoc(obj1)

        /**
         * if it is new quote once download status nee to change as process
         */
        if (statusId == 2) {
          await this.fnQuoteStatusUpdate(quoteId, 4)
          this.fnSearch()
        }

        //file name and path of the finance doc.
        let obj2 = {
          file_name: filePath.data
        }

        // Download finance doc
        window.open(`${store.state.serverPath}/` + filePath.data, '_blank')

        // Delete temp finsnce doc in the backend folder
        await quoteService.deleteTempFinanceDoc(obj2)
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Quote status - update',
          'Someting wrong on quote status update'
        )
      }

      messageService.fnSweetAlertSuccessToast(
        'Quote',
        'Quote downloaded successfully '
      )
    },

    // Quote calculation to send some data into download excel
    fnQuoteCalculation(quoteType, quoteId, quoteSingle) {
      return quoteCalculationService.calculation1(
        quoteType,
        quoteId,
        quoteSingle
      )
    },

    fnQuoteStatusUpdate: async function (quoteId, statusId) {
      let obj = {
        status: statusId
      }

      try {
        await quoteService.updateQuoteStatusOnly(quoteId, JSON.stringify(obj))
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Quote status - update',
          'Something wrong on quote status update'
        )
      }
    },

    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        dealerUserId: this.dealerUser.id,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminQuotePaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        dealerUserId: this.dealerUser.id,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchAdminQuotePaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        dealerUserId: this.dealerUser?.id,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminQuotePaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        dealerUserId: this.dealerUser?.id,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminQuotePaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      this.dealerUser = ''
      this.fromDate = ''
      this.toDate = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        dealerUserId: '',
        fromDate: '',
        toDate: '',
        sort_direction: 'asc',
        sort_field: 'sortOrder'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminQuotePaginate(objNew)
    },

    /**
     * Export Leads List into excel file and download
     */
    fnExport: async function () {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        dealerUserId: this.dealerUser.id,
        fromDate: this.fromDate,
        toDate: this.toDate,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      const filePath = await quoteService.createQuoteListExport(objNew)

      //file name and path of the finance doc.
      let obj3 = {
        file_name: filePath.data
      }

      // Download from Export QuoteList in temp folder
      window.open(`${store.state.serverPath}/` + filePath.data, '_blank')

      // Delete Export Quote List in temp folder
      await quoteService.deleteTempQuoteListExport(obj3)
    }
  },
  created() {
    // Store taxTable information in local storage
    taxTableService.storeTaxTable()
  },

  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      dealerUserId: '',
      sort_direction: 'asc',
      sort_field: 'sortOrder'
    }
    let objNew = { ...obj1, ...obj2 }
    await this.fetchAdminQuotePaginate(objNew)
    await this.fetchUserDropdownListBasedFullName()
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }
  .dealer-user-box {
    width: 300px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
<style scoped>
.multiselect {
  height: 35px !important;
  min-height: 35px !important;
}

.multiselect /deep/ .multiselect__tags {
  height: 35px !important;
  min-height: 35px !important;
  display: block;
  padding: 3px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}

.multiselect /deep/ .multiselect__select {
  height: 35px;
}
</style>
